import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Menu, MenuItem, Button } from '@material-ui/core'

const NavigationItems = ({classcode}) => {

  const style = {
    link: { color: 'black' }
  }

  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedItemText, setSelectedItemText] = useState('News Feed')

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const handleSelectIem = (text) => {
    handleClose()
  }

  useEffect(() => {
    let currentUrl = window.location.href
    let activeTab = currentUrl.split('/').pop()

    switch (activeTab) {
      case 'newsfeed':
        setSelectedItemText('Newsfeed')
        break;
      case 'classwork':
        setSelectedItemText('Classwork')
        break;
      case 'participants':
        setSelectedItemText('Participant')
        break;
      case 'grading':
        setSelectedItemText('Grading')
        break;
      default:
          break;
    }
  }, [])

  return (
    <div>
      <Button onClick={handleOpen}>
        {selectedItemText} &nbsp; <i className="fa fa-caret-down"></i>
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Link style={style.link} to={`/${classcode}/newsfeed`}>
          <MenuItem onClick={() => handleSelectIem('News Feed')}>News Feed</MenuItem>
        </Link>
        <Link style={style.link} to={`/${classcode}/classwork`}>
          <MenuItem onClick={() => handleSelectIem('Classwork')}>Classwork</MenuItem>
        </Link>
        <Link style={style.link} to={`/${classcode}/participants`}>
          <MenuItem onClick={() => handleSelectIem('Participants')}>Participants</MenuItem>
        </Link>
        <Link style={style.link} to={`/${classcode}/grading`}>
          <MenuItem onClick={() => handleSelectIem('Grading')}>Grading</MenuItem>
        </Link>
      </Menu>
    </div>
  )
}

export default NavigationItems